import * as DOMHelper from 'dom-lib';
export var dispalyName = 'DOMHelper';
export default DOMHelper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/DOMHelper/index.js
// module id = 2484
// module chunks = 35